import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useEffect } from 'react';
import useContentfulApi from '../api';
import { useContentfulDispatch, useContentfulSelector } from '../redux/hooks';
import { fetchPageComponent } from '../redux/pages.slice';
import { selectPageComponentById } from '../redux/selectors';
export const useComponent = (entryId, componentType) => {
    const dispatch = useContentfulDispatch();
    const api = useContentfulApi();
    const { selectedLocale } = useLocale();
    const component = useContentfulSelector((state) => selectPageComponentById(state, entryId));
    useEffect(() => {
        if (!entryId || !componentType)
            return;
        if (component)
            return;
        dispatch(fetchPageComponent({
            api,
            locale: selectedLocale,
            entryId,
            contentType: componentType,
        }));
    }, [api, component, componentType, dispatch, entryId, selectedLocale]);
    return component;
};
